module.exports = __webpack_public_path__ + "img/hot-bg-2.992a2b08.png";